/* eslint-disable react/prop-types */
import { createContext, useState } from 'react';

export const TextContext = createContext();

export const TextContextProvider = ({ children }) => {
  const [text, setText] = useState(`---
### Hop on for checking how the markdown looks
---`);

  const value = {
    text,
    setText,
  };

  return <TextContext.Provider value={value}>{children}</TextContext.Provider>;
};
